module.exports = __webpack_public_path__ + "images/New Interaction V2.svg";